import Axios from 'axios';

export class Tabs {
    constructor() {
        this.regularTabs();

        const viewAllLanguageTabsButtons = document.querySelectorAll('.nav-tabs-wrapper .view-all-language-tabs');

        document.querySelectorAll('.nav-tabs-language a').forEach(link => {
            link.addEventListener('click', function() {
                const href = link.getAttribute('href');
                const hash = href.substring(href.indexOf('#') + 1);

                localStorage.setItem('activeTab', hash);
            });
        });

        if (localStorage.getItem('activeTab')) {
            const activeTab = localStorage.getItem('activeTab');
            const tab = document.querySelector(`.nav-tabs-language a[href="#${activeTab}"]`);

            if (tab) {
                tab.click();
            }
        }

        if (viewAllLanguageTabsButtons.length) {
            viewAllLanguageTabsButtons.forEach(button => {
                const navTabsLanguage = button.closest('.nav-tabs-wrapper')?.querySelector('.nav-tabs-language');

                if (!navTabsLanguage) {
                    return;
                }

                const hasInactiveTabs = [...navTabsLanguage.querySelectorAll('.nav-link')].some(tab => this.isInactiveLanguageTab(tab));

                if (!hasInactiveTabs) {
                    button.style.display = 'none';

                    return;
                }

                button.onclick = event => {
                    const showHideButton = event.currentTarget;
                    const show = showHideButton.dataset.showInactiveLanguageTabs === '1' ? false : true;

                    this.toggleNotEnabledLanguageTabs(show, navTabsLanguage);
                    showHideButton.dataset.showInactiveLanguageTabs = show ? 1 : 0;
                    showHideButton.innerHTML = show ? showHideButton.dataset.hideText : showHideButton.dataset.showText;

                    Axios.post(adminPath('admin/preferences/ajax-update'), {
                        preference: 'show_inactive_language_tabs',
                        value: show ? 1 : 0
                    });

                    if (show === false) {
                        this.goToFirstVisibleTab(navTabsLanguage);
                    }
                };

                this.toggleNotEnabledLanguageTabs(button.dataset.showInactiveLanguageTabs === '1', navTabsLanguage);
            });
        }
    }

    getActiveLanguagesParsed()
    {
        try {
            return JSON.parse(activeLanguages);
        } catch (error) {
            return {};
        }
    }

    isInactiveLanguageTab(tab)
    {
        const activeLanguagesParsed = this.getActiveLanguagesParsed();

        return activeLanguagesParsed[tab.dataset.language] === false;
    }

    toggleNotEnabledLanguageTabs(show, navTabsLanguage = null)
    {
        const languageTabsElement = typeof navTabsLanguage === 'string'
            ? document.querySelector(`.nav-tabs-language.${navTabsLanguage}`)
            : navTabsLanguage;

        if (!languageTabsElement) {
            return;
        }

        const tabs = languageTabsElement.querySelectorAll('.nav-link');
        const activeLanguagesParsed = this.getActiveLanguagesParsed();

        tabs.forEach(tab => {
            const tabContentId = tab.dataset.tabId || (tab.getAttribute('href') ? tab.getAttribute('href').replace('#', '') : null);
            let tabContent = tabContentId ? document.getElementById(tabContentId) : null,
                inputElements = [];

            if (tabContent !== null) {
                inputElements = tabContent.querySelectorAll('input, select, textarea');
            }

            if (activeLanguagesParsed[tab.dataset.language] === false && show === false) {
                tab.parentElement.style.display = 'none';

                inputElements.forEach(inputElement => {
                    inputElement.required = false;
                });
            } else {
                tab.parentElement.style.display = 'list-item';

                inputElements.forEach(inputElement => {
                    if (inputElement.hasAttribute('data-required')) {
                        inputElement.required = true;
                    }
                });
            }
        });
    }

    goToFirstVisibleTab(navTabsLanguage = null) {
        const tabs = navTabsLanguage
            ? navTabsLanguage.querySelectorAll('.nav-link')
            : document.querySelectorAll('.nav-tabs .nav-link');
        const activeLanguagesParsed = this.getActiveLanguagesParsed();

        for (let k = 0; k < tabs.length; k++) {
            let tab = tabs[k];

            if (activeLanguagesParsed[tab.dataset.language] === true && tab.parentElement.style.display !== 'none') {
                tab.click();

                break;
            }
        }
    }

    regularTabs() {
        document.querySelectorAll('.tabbable:not(.language_tabs) > .nav-link').forEach((el) => {
            el.addEventListener('click', () => {
                window.location.hash = el.getAttribute('href');

                document.querySelectorAll('.tabbable .tab-pane').forEach((pane) => {
                    pane.classList.remove('active');
                });

                document.querySelectorAll('.tabbable .nav-item').forEach((pane) => {
                    pane.classList.remove('show');
                });

                document.querySelector(el.getAttribute('href')).classList.add('active');
                document.querySelector(`.tabbable .nav-link[href=\\${el.getAttribute('href')}]`).closest('li').classList.add('show');

                document.documentElement.scrollTop = 0;
            });
        });

        let tab = document.querySelector(`.tabbable:not(.language_tabs) .nav-tabs ${window.location.hash && document.querySelector(`a[href=\\${window.location.hash}]`) ? `a[href=\\${window.location.hash}]` : 'a'}`);

        if (tab) {
            tab.click();
        }
    }
}
